import { render, staticRenderFns } from "./PharmacyDashboard.vue?vue&type=template&id=53778d0b&"
import script from "./PharmacyDashboard.vue?vue&type=script&lang=js&"
export * from "./PharmacyDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports